export default __webpack_public_path__ + "media/Motivation.b1735da5.svg";